import { logAssetsError } from './common/logging';
import { trackEvent } from './common/tracking';
import { delivery } from '@otto-ec/nexus-registry/delivery';
import { SelectedSampleAddress } from '@otto-ec/nexus-registry/delivery/sampleAddressSelection';

export function setupAddressPage({
    variationsInput,
    backButton,
    formDiv,
    errorBanner
}: {
    variationsInput: HTMLElement;
    backButton: HTMLElement | null;
    formDiv: HTMLElement;
    errorBanner: HTMLElement;
}) {
    const variationId = variationsInput.dataset.variationId ?? '';
    const variations: string[] = JSON.parse(variationsInput.dataset.variations || '[]');
    const trackingType: string = variationsInput.dataset.trackingType || '';
    const confirmationUrl: string = variationsInput.dataset.confirmationUrl || '';

    if (backButton) {
        backButton.onclick = event => {
            event.preventDefault();
            history.back();
        };
        backButton.dataset.initialized = 'true';
    } else {
        logAssetsError('Back button from dad-view ESI missing!');
    }

    async function onSelectedAddress(address: any) {
        let data: Record<string, any> = {};
        const response = await fetch('/order-sample/order', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ address, variations })
        });
        if (response.ok) {
            data = {
                order_SampleOrderStep: 'order',
                order_SampleOrderType: trackingType,
                order_SampleOrderCount: variations.length.toString(),
                order_VariationId: variationId,
                ot_PageCluster: 'SampleOrderFlow'
            };
            trackEvent(data);
            window.location.href = `${location.protocol}/*                                  */
        } else {
            const result: OrderResponse = await response.json();
            data = {
                order_SampleOrderStep: 'order',
                order_SampleOrderType: trackingType,
                order_SampleOrderCount: variations.length.toString(),
                order_Message: `order.sample.${result.failureReason}`,
                order_VariationId: variationId,
                ot_PageCluster: 'SampleOrderFlow'
            };
            trackEvent(data);
            if (result.failureReason === 'error.variations.unavailable') {
                redirectWithSelection(variationId, variations);
            } else {
                errorBanner.removeAttribute('hidden');
                logAssetsError(`Samples order failed: ${JSON.stringify(result)}`);
            }
        }
    }

    delivery.sampleAddressSelection.assignNamespace({
        selectSampleAddress: (selectedSampleAddress: SelectedSampleAddress) => onSelectedAddress(selectedSampleAddress.addressData)
    });
}

type OrderResponse = {
    failureReason: 'error.technical' | 'error.variations.unavailable' | 'error.input';
};

function redirectWithSelection(variationId: string, variations: string[]) {
    const { location } = window;
    const currentUrlParams = new URLSearchParams(location.search);
    const productId = currentUrlParams.get('productId');
    const redirectUrlParams = new URLSearchParams();

    const redirectPath = `/order-sample/samples/${productId}`;
    redirectUrlParams.append('focussedDialogCloseUrl', currentUrlParams.get('focussedDialogCloseUrl') || `/p/${productId}`);
    redirectUrlParams.append('variations', variations.toString());
    redirectUrlParams.append('unavailable', 'true');
    if (variationId !== '') {
        redirectUrlParams.append('variationId', variationId);
    }

    location.assign(`${location.protocol}/*                                                                */
}
